import React from 'react';
import { 
  GlobalAlertType, 
  StoreAction, 
  ElementLegend,
  fuelCat,
  fuelCode,
} from '../types';

type Dispatch = React.Dispatch<StoreAction>;

export function showAlert (label, msg) {
  let my_obj_str = JSON.stringify(msg);
  window.alert(label + '= ' + my_obj_str );
}


export const useAddAlert = (dispatch: Dispatch) =>
  React.useCallback(
    (payload: GlobalAlertType)=>
      dispatch({
        type: 'ADD_ALERT',
        payload,
      }),
    [dispatch]
  );

export const useCloseAlert = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: string)=>
      dispatch({
        type: 'REMOVE_ALERT',
        payload,
    }),
  [dispatch]
);

export const useInitAlerts = (dispatch: Dispatch) => 
  React.useCallback(
    ()=>
      dispatch({
        type: 'INIT_ALERTS',
        payload:[],
    }),
  [dispatch]
);

export const useElementRadioSelect = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'ELEMENT_RADIO_SELECTED',
        payload,
    }),
  [dispatch]
);

export const useElementSelection = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'ELEMENT_SELECTION',
        payload,
    }),
  [dispatch]
);

export const useBaseMapSelection = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'BASE_MAP_SELECTION',
        payload,
    }),
  [dispatch]
);

export const useColorLegend = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: boolean)=>
      dispatch({
        type: 'SET_COLOR_LEGEND',
        payload,
    }),
  [dispatch]
);

export const useCreateTable = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: ElementLegend[])=>
      dispatch({
        type: 'CREATE_TABLE',
        payload,
    }),
  [dispatch]
);

export const useSelectTableStation = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SELECT_TABLE_STATION',
        payload,
    }),
  [dispatch]
);

export const useAllStations = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'ALL_STATIONS',
        payload,
    }),
  [dispatch]
);

export const useBoundaries = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_BOUNDARY',
        payload,
    }),
  [dispatch]
);

export const useMidDateSelected = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_MID_DATE_SELECT',
        payload,
      }),
    [dispatch]
);

export const useWindSpeed = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_WIND_SPEED',
        payload,
    }),
  [dispatch]
);

export const useDates = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_DATES',
        payload,
      }),
    [dispatch]
  );

export const useWindDirection = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_WIND_DIRECTION',
        payload,
    }),
  [dispatch]
);

export const useCompleted = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'CALL_COMPLETED',
        payload,
    }),
  [dispatch]
);

export const useStationWasClick = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'STATION_CLICKED',
        payload,
    }),
  [dispatch]
);

export const useStationThatWasClicked = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'STATION_CLICKED_ON_MAP',
        payload,
    }),
  [dispatch]
);

export const useCurrentDate = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'CURRENT_DATE',
        payload,
    }),
  [dispatch]
);

export const useCurrentDateSlider = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'CURRENT_SLIDER_DATE',
        payload,
    }),
  [dispatch]
);

export const useCurrentZoom = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'CURRENT_ZOOM',
        payload,
    }),
  [dispatch]
);

export const useGetWeatherObs = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'WEATHER_OBS',
        payload,
    }),
  [dispatch]
);

export const useGetWeatherMinMax = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'WXMINMAX',
        payload,
    }),
  [dispatch]
);

export const useFeaturesRendered = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'FEATURES_RENDERED',
        payload,
    }),
  [dispatch]
);

export const useFilters = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_FILTERS',
        payload,
    }),
  [dispatch]
);

export const useElevationFilter = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_ELEVATION_FILTER',
        payload,
    }),
  [dispatch]
);

export const useTimeZone = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_TIME_ZONE',
        payload,
    }),
  [dispatch]
);

export const useInitialLoad = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_INITIAL_LOAD',
        payload,
    }),
  [dispatch]
);

export const useChartTableSelect = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_CHART_TABLE',
        payload,
    }),
  [dispatch]
  );

  export const usePopUpContent = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_POPUP_CONTENT',
        payload,
    }),
  [dispatch]
  );

  export const useLatLong = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_LAT_LONG',
        payload,
    }),
  [dispatch]
  );

  export const useSiteType = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_SITE_TYPE',
        payload,
    }),
  [dispatch]
  );
  export const useGT50Displayed = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_GT50',
        payload,
    }),
  [dispatch]
  );
  export const useGT05Displayed = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_GT05',
        payload,
    }),
  [dispatch]
  );
  export const useSF100Displayed = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_SF100',
        payload,
    }),
  [dispatch]
  );
  
  export const useNOAA100Displayed = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_NOAA100',
        payload,
    }),
  [dispatch]
  );

    
  export const useProdBanner = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_PROD_BANNER',
        payload,
    }),
  [dispatch]
  );

  export const useAllLegend = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_ALL_LEGEND',
        payload,
      }),
      [dispatch]
  );
  
  export const useSearchedStation = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_SEARCHED_STATION',
        payload,
    }),
  [dispatch]
  );

  export const useUser = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_USER',
        payload,
    }),
  [dispatch]
  );

  export const useUserTokens = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_TOKENS',
        payload,
    }),
  [dispatch]
  );

  export const useWeatherData = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any[])=>
      dispatch({
        type: 'SET_WEATHER_DATA',
        payload,
    }),
  [dispatch]
  );

  export const useFSMapStartDate = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_FS_START_DATE',
        payload,
    }),
  [dispatch]
  );

  export const useFSMapEndDate = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any)=>
      dispatch({
        type: 'SET_FS_END_DATE',
        payload,
    }),
  [dispatch]
  );

  export const useFSMapCategory = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: string|null)=>
      dispatch({
        type: 'SET_FS_CATEGORY',
        payload,
    }),
  [dispatch]
  );

  export const useFSMapFuel = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: fuelCat|null)=>
      dispatch({
        type: 'SET_FS_FUEL',
        payload,
    }),
  [dispatch]
  );

  export const useFSMapMethod = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: fuelCode)=>
      dispatch({
        type: 'SET_FS_METHOD',
        payload,
    }),
  [dispatch]
  );

  export const useFSMapSubCat = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: fuelCode)=>
      dispatch({
        type: 'SET_FS_SUB_CAT',
        payload,
    }),
  [dispatch]
  );

  export const useMapDataType = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: string)=>
      dispatch({
        type: 'SET_MAP_DATATYPE',
        payload,
    }),
  [dispatch]
  );

  export const useNfdrFuelModelSelected = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: string)=>
      dispatch({
        type: 'NFDR_FUEL_MODEL_SELECTED',
        payload,
    }),
  [dispatch]
  );


  export const useSubCatList = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any[])=>
      dispatch({
        type: 'SET_SUB_CAT_LIST',
        payload,
    }),
  [dispatch]
  );

  export const useMethodList = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any[])=>
      dispatch({
        type: 'SET_METHOD_LIST',
        payload,
    }),
  [dispatch]
  );


  export const useCategoryList = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any[])=>
      dispatch({
        type: 'SET_CATEGORY_LIST',
        payload,
    }),
  [dispatch]
  );

  export const useFuelList = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any[])=>
      dispatch({
        type: 'SET_FUEL_LIST',
        payload,
    }),
  [dispatch]
  );

export const useSeasonalTrend = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any[])=>
      dispatch({
        type: 'SET_SEASONAL_TREND_CHARTS',
        payload,
    }),
  [dispatch]
  );

export const useNetworkType = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: any[])=>
      dispatch({
        type: 'SET_NETWORK',
        payload,
    }),
  [dispatch]
);

export const useOpenCalc = (dispatch: Dispatch) => 
  React.useCallback(
    (payload: boolean)=>
      dispatch({
        type: 'SET_OPEN_CALC',
        payload,
    }),
  [dispatch]
);
